module.exports = __webpack_public_path__ + "img/Digital Marketing Solutions Summit.b442041b.png";